'use es6';

import PropTypes from 'prop-types';
import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFieldset from 'UIComponents/form/UIFieldset';
import { KeyTypes, PopoverType } from '../../constants/popover';
import { isValidAnchorId } from '../../utils/anchor';
import { isWhitespace } from '../../utils/url';
import ExplicitSaveControls from '../ExplicitSaveControls';
import { AnchorInputField, HowToUseAnchorsTooltip } from './sharedComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = suffix => `RichTextLib.anchor.${suffix}`;
const propTypes = {
  popoverType: PropTypes.oneOf(Object.values(PopoverType)).isRequired,
  tooltipClassName: PropTypes.string,
  anchorId: PropTypes.string,
  anchorList: PropTypes.arrayOf(PropTypes.string),
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};
const defaultProps = {
  anchorId: ''
};
function AnchorPopoverBodyControls(props) {
  const {
    popoverType,
    tooltipClassName,
    anchorId: initialAnchorId,
    anchorList,
    onSubmit,
    onClose
  } = props;
  const [anchorId, setAnchorId] = useState(initialAnchorId);
  const [isInvalidAnchorId, setIsInvalidAnchorId] = useState(false);
  const canSubmit = !isWhitespace(anchorId) && !isInvalidAnchorId && anchorId !== initialAnchorId;
  const handleAnchorIdChange = evt => {
    const {
      value
    } = evt.target;
    setAnchorId(value);
    setIsInvalidAnchorId(!isValidAnchorId(value));
  };
  const handleSubmit = () => {
    if (anchorList.includes(anchorId)) {
      setIsInvalidAnchorId('duplicate');
    } else {
      onSubmit(anchorId);
    }
  };
  const handleKeyDown = evt => {
    if (evt.key === KeyTypes.ESCAPE) {
      onClose();
    } else if (evt.key === KeyTypes.ENTER && canSubmit) {
      handleSubmit();
      evt.preventDefault();
    }
  };
  return /*#__PURE__*/_jsxs(UIFieldset, {
    className: "small-popover-body p-all-5",
    onKeyDown: handleKeyDown,
    _size: "small",
    children: [/*#__PURE__*/_jsx("h4", {
      className: "m-bottom-2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey(`${popoverType}Title`)
      })
    }), /*#__PURE__*/_jsx(AnchorInputField, {
      i18nKey: i18nKey,
      anchorId: anchorId,
      invalidAnchorId: isInvalidAnchorId,
      onChange: handleAnchorIdChange
    }), /*#__PURE__*/_jsx(HowToUseAnchorsTooltip, {
      i18nKey: i18nKey,
      tooltipClassName: tooltipClassName
    }), /*#__PURE__*/_jsx(ExplicitSaveControls, {
      className: "p-top-4",
      popoverType: popoverType,
      isSubmitDisabled: !canSubmit,
      onSubmit: handleSubmit,
      onCancel: onClose
    })]
  });
}
AnchorPopoverBodyControls.propTypes = propTypes;
AnchorPopoverBodyControls.defaultProps = defaultProps;
AnchorPopoverBodyControls.displayName = 'AnchorPopoverBodyControls';
export default AnchorPopoverBodyControls;